import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import Securels from "secure-ls"

// 加密
const ls = new Securels({
    encodingType: "aes",
    isCompression: false,
    encryptionSecret: "QHdWe6SQN4fdrxY8s45DNwFZEMfwCJ8apk8rSbeT-YisW4rzcG4bKYRNEx3DZkPX"
})
const storageLike = {
    setItem(key, value) {
        ls.set(key, value)
    },
    getItem(key) {
        return ls.get(key)
    }
}
// 实例化
const pinia = createPinia();
// 持久化
pinia.use(piniaPluginPersistedstate);

export {
    pinia,
    storageLike
}